import {
  login, //其他
  jzLogin, //职业技能工
  logout,
  getInfo,
  refreshToken
} from '@/apiCloud/login'
import {
  getToken,
  setToken,
  setExpiresIn,
  removeToken,
  getTokenId,
  setTokenId,
} from '@/utilsCloud/auth'

const user = {
  state: {
    token: getToken(),
    tokenId: getTokenId(),
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    nickName: '',
    userType: '',
    isLogin: false,
    isEnterPrise: false,
    empId: null
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_NICKNAME: (state, nickName) => {
      state.nickName = nickName
    },
    SET_ISLOGIN: (state, isLogin) => {
      state.isLogin = isLogin
    },
    SET_ISENTERPRISE: (state, isEnterPrise) => {
      state.isEnterPrise = isEnterPrise
    },
    SET_USERTYPE: (state, userType) => {
      state.userType = userType
    },
    SET_EMP_ID: (state, value) => {
      state.empId = value
    }
  },

  actions: {
    // 登录
    Login({
      commit
    }, userInfo) {
      const username = userInfo.username.trim();
      const password = userInfo.password;
      const entpId = userInfo.entpId;
      const trainingValue = userInfo.trainingValue;
      // const userType = userInfo.userType;
      // console.log('dsdsa', username, password, entpId)
        if(trainingValue == 1){
          return new Promise((resolve, reject) => {
            jzLogin(username, password, entpId).then(res => {
              let data = res.data
              setToken(data.access_token)
              setTokenId(data.access_token)
              commit('SET_TOKEN', data.access_token)
              setExpiresIn(data.expires_in)
              commit('SET_EXPIRES_IN', data.expires_in)
              resolve()
            }).catch(error => {
              reject(error)
            })
          })
        }else{
          return new Promise((resolve, reject) => {
            login(username, password, entpId).then(res => {
              let data = res.data
              setToken(data.access_token)
              setTokenId(data.access_token)
              commit('SET_TOKEN', data.access_token)
              setExpiresIn(data.expires_in)
              commit('SET_EXPIRES_IN', data.expires_in)
              resolve()
            }).catch(error => {
              reject(error)
            })
          })
        }
    },

    // 获取用户信息
    GetInfo({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res.user
          const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/images/default_avatar.png") : user.avatar;
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          // commit('SET_NAME', user.userName)
          commit('SET_AVATAR', avatar)
          commit('SET_NICKNAME', user.nickName)
          commit('SET_USERTYPE', user.userType)
          commit('SET_EMP_ID', user.objectId)

          if (res.code == 200) {
            // 登录状态
            commit('SET_ISLOGIN', true)
            // 是否为企业
            commit('SET_ISENTERPRISE', user.userType == '02' || user.userType == '01')
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 刷新token
    RefreshToken({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        refreshToken(state.token).then(res => {
          setExpiresIn(res.data)
          commit('SET_EXPIRES_IN', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          commit('SET_ISLOGIN', false)
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js